<template>
  <Modal v-model="model" title="呼出内线" sticky reset-drag-position @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="message_template_pop Internal_call" :styles="modelHeight" width="800">
    <div class="input_single">
      <div class="font_style_set"><span style="color: #ed4014">*</span>员工工号:</div>
      <Input v-model="agentNum" class="input_content" @on-change="searchEmployee" clearable/>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:30%;">在线状态</th>
            <th class="font_style_set" style="width:30%;">员工工号</th>
            <th class="font_style_set" style="width:40%;">员工姓名</th>
          </tr>
        </table>
      </div>
      <div class="footer_style">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}" @click="getAgentNumber(item.agentNumber)">
            <td  style="width:30%;">{{item.employeeOnLineState}}</td>
            <td  style="width:30%;">{{item.agentNumber}}</td>
            <td  style="width:40%;">{{item.employeeName}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="btn_template" style="width: 100%;">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">确定</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "InternalCallScreenPop",
      props:{
        showInternalCall:Boolean
      },
      data(){
        return{
          model:false,
          spinShow:true,
          agentNum:'',
          modelHeight:{'top':'50px'},
          infoTableList:[],
          oldTableList:[]
        }
      },
      methods:{
        searchEmployee:function(){
          if(!this.agentNum){
            this.infoTableList=this.oldTableList;
            return false;
          }
          this.infoTableList=[];
          for (let i=0;i<this.oldTableList.length;i++){
            let agentNumber=this.oldTableList[i].agentNumber;
            if(agentNumber.indexOf(this.agentNum)!="-1"){
              this.infoTableList.push(this.oldTableList[i]);
            }
          }
        },
        getAgentNumber:function (agentNumber) {
          this.agentNum=agentNumber;
        },
        cancel:function () {
          this.$emit("closeInternal",false)
        },
        save:function () {
          if(!this.agentNum){
            this.$Message.info("内呼员工工号不能为空");
            return false;
          }
          this.$emit("closeInternal",true,this.agentNum);
        },
        initSearch:function(){
           this.agentNum='',
          this.spinShow=true;
          let that=this;
          let param={
            journalType:"null",
            menuId:"null"
          };
          this.$http.post("popUp/getInternalCall.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.infoTableList=res.data.obj;
            that.oldTableList=res.data.obj
          });
        }
      },
      watch:{
        showInternalCall:function () {
          this.model=this.showInternalCall;
          if(this.showInternalCall){
            this.initSearch();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/loginHeadMange/InternalCallScreenPop.vue